import { Button, Typography } from '@mui/material'
import tw from 'twin.macro'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import { SignInForm } from 'src/components/auth/sign-in-form/SignInForm'
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { useCallback, useMemo } from 'react'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { getPartnerPublicInfo } from 'src/selectors/partner'

export const ClientSignInPage = () => {
  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()

  const partner = useSelector(getPartnerPublicInfo)

  const isContinue = useMemo(() => Boolean(location?.state?.isContinue), [location])

  const handleSuccess = (phone: string) => {
    navigate(`/client/${params.partnerName}/enter-code`, { state: { phone } })
  }

  const handleBack = useCallback(() => {
    navigate(-1)
  }, [])

  if (!params?.partnerName) {
    return <Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ClientPublicWrapper>
      {isContinue && (
        <Button
          css={tw`bg-primary-100 h-[42px] w-[82px] hover:bg-primary-200 mb-4`}
          onClick={handleBack}
        >
          <div css={tw`items-center flex flex-row`}>
            <ChevronLeftMinor css={tw`fill-primary-500`} width={19} />
            <Typography css={tw`[font-weight: 600] text-primary-500`}>Back</Typography>
          </div>
        </Button>
      )}
      <Typography variant="h2" css={tw`mb-2`}>
        {`${isContinue ? 'Continue' : 'Begin'} your onboarding${
          partner?.displayName ? ` with ${partner?.displayName}` : ''
        }`}
      </Typography>
      <Typography css={tw`mb-6 text-shades-400`}>
        {isContinue
          ? 'To proceed, please enter the phone number you used during the onboarding process.'
          : 'Securely log in with your phone number to swiftly upload documents for verification.'}
      </Typography>
      <SignInForm
        platform="client"
        isContinue={isContinue}
        partnerName={params.partnerName}
        onSuccess={handleSuccess}
      />
    </ClientPublicWrapper>
  )
}
